import { isPlatformServer, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

import { RouteLanguageService } from '../../services/route-language.service';

@Component({
  selector: 'app-cookie',
  standalone: true,
  imports: [RouterLink, TranslateModule, NgOptimizedImage],
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieComponent implements OnInit {
  private cookieService = inject(CookieService);

  protected readonly isCookieBannerVisible = signal(false);
  private readonly ACCEPT_COOKIE_KEY = 'ACCEPT_POLICY';
  public language: string = 'en';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private routeLanguageService: RouteLanguageService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.routeLanguageService.routeLanguage.subscribe(res => {
      this.language = res;

      this.showCookieBanner();
      this.cd.markForCheck();
    })
  }

  public acceptCookie(): void {
    this.cookieService.set(this.ACCEPT_COOKIE_KEY, 'true', 1);
    this.isCookieBannerVisible.set(false);
  }

  private showCookieBanner(): void {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    if (this.cookieService.get(this.ACCEPT_COOKIE_KEY) !== 'true') {
      this.isCookieBannerVisible.set(true);
    }
  }
}
